import "./Banner1.css";

import React from "react";
import HydrationSafeSlider from "../../utils/HydrationSafeSlider";

function Banner1() {
  const settings = {
    dots: true,
    infinite: true,
    slidesToShow: 5,
    slidesToScroll: 1,
    autoplay: true,
    speed: 2000,
    autoplaySpeed: 2000,
    cssEase: "linear",
    responsive: [
      {
        breakpoint: 1400,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
          infinite: true,
          dots: false,
        },
      },
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
          dots: false,
        },
      },
      {
        breakpoint: 780,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
          dots: false,
        },
      },
      {
        breakpoint: 450,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
          dots: false,
        },
      },
    ],
  };
  return (
    <div className="slider-container">
      <HydrationSafeSlider settings={settings}>
        <div className="slide">
          <div className="slide-text">
            <div className="dot-layout"> </div>
            Digital
          </div>
        </div>
        <div className="slide">
          <div className="slide-text">
            <div className="dot-layout"> </div>
            Marketing
          </div>
        </div>
        <div className="slide">
          <div className="slide-text">
            <div className="dot-layout"> </div>
            Development
          </div>
        </div>
        <div className="slide">
          <div className="slide-text">
            <div className="dot-layout"> </div>
            Designing
          </div>
        </div>
        <div className="slide">
          <div className="slide-text">
            <div className="dot-layout"> </div>
            Solutions
          </div>
        </div>
      </HydrationSafeSlider>
    </div>
  );
}

export default Banner1;
